import { Autocomplete, InputLabel, TextField } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import Affair from 'types/entities/Affair';
import Devise from 'types/entities/Devise';
import PurchaseOrders from 'types/entities/PurchaseOrders';
import Scope from 'types/entities/Scope';
import User from 'types/entities/User';
import Workunit from 'types/entities/Workunit';

export type SelectTypeOptions = Affair | Scope | Devise | User | Workunit | PurchaseOrders;
export type PropertyNameOptions = 'affair' | 'scope' | 'devise' | 'customer' | 'workunit' | 'purchase_order';

type SelectProps = {
  options: SelectTypeOptions[];
  selectedOption: SelectTypeOptions | undefined | null;
  defaultOption?: SelectTypeOptions;
  optionsLabels: keyof SelectTypeOptions | 'name' | 'reference' | 'value' | 'otp';
  label: ReactNode;
  handleSelectOptions: (opt: SelectTypeOptions | null, propertyName: PropertyNameOptions) => void;
  propertyName: PropertyNameOptions;
  required?: boolean;
  disabled?: boolean;
  classNameLabel?: string;
  disableClearable?: boolean;
  id?: string;
  variant?: any;
  poref?: string;
};
const AutocompleteCustom = (props: SelectProps) => {
  const {
    options,
    selectedOption,
    handleSelectOptions,
    label,
    optionsLabels,
    propertyName,
    required = false,
    disabled = false,
    defaultOption,
    classNameLabel = '',
    disableClearable = false,
    id,
    variant,
  } = props;

  return (
    <>
      <InputLabel htmlFor={id}>
        {label} {required && '*'}
      </InputLabel>
      <Autocomplete
        options={options || []}
        autoHighlight
        fullWidth
        getOptionLabel={(option: any) => {
          if (typeof option === 'string') return option;
          const label = option[optionsLabels] ?? option.name ?? option.reference ?? '';
          return label.toString();
        }}
        disableClearable={disableClearable}
        isOptionEqualToValue={(option, value) => option && value && option.id === value.id}
        disabled={disabled}
        value={selectedOption || null}
        defaultValue={defaultOption || selectedOption}
        onChange={(e, value) => handleSelectOptions(value, propertyName)}
        renderOption={({ key, ...optionProps }: any, option: any) => (
          <li key={option.id ?? key} {...optionProps}>
            {option[optionsLabels] ?? option.name ?? option.reference ?? ''}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            required={required}
            disabled={disabled}
            variant={variant}
            inputProps={{
              autoComplete: '',
              ...params.inputProps,
            }}
          />
        )}
      />
    </>
  );
};
export default AutocompleteCustom;
